module.exports = __webpack_public_path__ + "static/media/i_pad_pro@2x.ddfa61b1.jpg";